<span class="feedback-id-cell">
  <a class="feedback-id-link" href="#" (click)="onClickFeedbackId($event)">
    {{ feedbackId }}
    @if (isUnread) {
      <sup class="unread-new" aria-label="New feedback">New</sup>
    }
  </a>
</span>
